var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoinIcon = function SvgCoinIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.5,
    r: 17,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04309 12.0307L11.0481 19.1294V23.0111H13.3536V19.1294L17.3586 12.0307H14.7583L12.2545 16.7596H12.1472L9.64342 12.0307H7.04309Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5833 15.1887H26.8083C26.7761 13.2317 25.1677 11.8806 22.7228 11.8806C20.3155 11.8806 18.5516 13.2103 18.5623 15.2047C18.5569 16.8239 19.6989 17.7515 21.554 18.1965L22.7496 18.4967C23.9452 18.7862 24.6101 19.1294 24.6154 19.8693C24.6101 20.6735 23.8487 21.2204 22.6692 21.2204C21.4629 21.2204 20.5943 20.6628 20.5192 19.5637H18.2728C18.3317 21.9388 20.0313 23.1666 22.696 23.1666C25.3768 23.1666 26.953 21.8852 26.9584 19.8746C26.953 18.0463 25.5751 17.0759 23.6664 16.647L22.6799 16.4111C21.7256 16.1913 20.9267 15.8374 20.9428 15.0493C20.9428 14.3415 21.5701 13.8215 22.7067 13.8215C23.8166 13.8215 24.4975 14.3255 24.5833 15.1887Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coinIcon.239af305.svg";
export { ForwardRef as ReactComponent };